var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VuePhoneNumberInput',{attrs:{"color":"#fb6340","size":"lg","required":_vm.required,"no-example":true,"fetch-country":true,"translations":{
    countrySelectorLabel: _vm.$t('COMMON.COUNTRY_CODE'), //'Code pays',
    countrySelectorError: _vm.$t('COMMON.SELECT_COUNTRY'), //'Choisir un pays',
    phoneNumberLabel: _vm.$t('COMMON.PHONE_NUMBER'), //'Numéro de téléphone'
  }},on:{"update":_vm.onChangePhoneNumber},model:{value:(_vm.phoneNumberModel),callback:function ($$v) {_vm.phoneNumberModel=$$v},expression:"phoneNumberModel"}})
}
var staticRenderFns = []

export { render, staticRenderFns }